<template>
  <v-alert type="info"
  class="align-self-start" 
  prominent dense outlined>
    Disclaimer:
    <li class="ml-3">
      Reference database coverage: 
      <a href="examples/nis_18sdb_match.txt"
      target="_blank">
      {{NISList.count}} entries for NIS
      </a>,       
      <a href="examples/unwanted_18sdb_match.txt"
      target="_blank">
        {{unwantedList.count}} entries for unwanted and notifiable organism list</a> 
      (last updated: {{ unwantedList.timestamp }})
    </li>
    <li class="ml-3">
      We are not responsible for incompleteness of the reference database and undiscovered/undetected species
    </li>
    <li class="ml-3">
      This website is free and open to all users and there is no login requirement
    </li>
  </v-alert>
</template>



<script>
export default {
  name: "Disclaimer",
  props: {
    unwantedList: {
      type: Object,
      default: () => {
        return { unwanted: [], timestamp: "NA" };
      },
    },
    NISList: {
      type: Object,
      default: () => {
        return { NIS: [], timestamp: "NA" };
      },
    },
  },
};
</script>

<style scoped></style>
